import { AddressKind, AddressModel } from '@ail/customers-api'
interface Props {
  address: AddressModel
  onClick: () => void
}
export default function AddressListItem({ address, onClick }: Props) {
  const icon =
    address.kind === AddressKind.Delivery
      ? 'icon-marker'
      : address.kind === AddressKind.Primary
      ? 'icon-customers'
      : 'icon-4u'

  return (
    <li onClick={onClick} className="contactListItem" key={Math.random()}>
      <div className="contactsDetails">
        <i className={icon} />
        {address.street && <span>{address.street}</span>}
        {address.postalCode && <span>{address.postalCode}</span>}
        {address.city && <span>{address.city}</span>}
      </div>
    </li>
  )
}
